<template>
  <v-row align="center">
    <v-col cols="auto" class="pr-0">
      <v-checkbox
        v-model="taskCheckbox"
        hide-details="true"
        @change="submit"
        class="pt-0 mt-0"
        :disabled="loading"
      >
      </v-checkbox>
    </v-col>
    <v-col class="pl-0">
      <span :class="{ 'text-decoration-line-through': taskCheckbox }">
        <slot name="title"> {{ task.title }} </slot>
      </span>

      <v-chip small class="ml-3" v-if="task.assigned_to" color="primary">
        {{ task.assigned_to.name }}
      </v-chip>
      <v-chip small class="ml-3" v-else>Unassigned</v-chip>

      <v-chip small class="ml-3" color="error" v-if="task.urgent">
        Urgent
      </v-chip>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TaskCheckbox',
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    taskCheckbox: false,
    loading: false
  }),
  watch: {
    'task.completed': {
      immediate: true,
      handler() {
        this.taskCheckbox = this.task.completed
      }
    }
  },
  methods: {
    ...mapActions('tasks', ['updateTaskCompleted']),
    submit() {
      this.loading = true
      this.updateTaskCompleted({
        id: this.task.id,
        completed: this.taskCheckbox
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
